import { useState, useEffect } from 'react';
import { goalStorage } from '../utils/localStorage';

export const useGoals = () => {
  const [goals, setGoals] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadGoals = () => {
    setLoading(true);
    try {
      const allGoals = goalStorage.getAll();
      setGoals(allGoals);
    } catch (error) {
      console.error('Error loading goals:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadGoals();
  }, []);

  const addGoal = (goalData) => {
    try {
      const newGoal = goalStorage.add(goalData);
      setGoals(prev => [...prev, newGoal]);
      return newGoal;
    } catch (error) {
      console.error('Error adding goal:', error);
      return null;
    }
  };

  const updateGoal = (id, updates) => {
    try {
      const updatedGoal = goalStorage.update(id, updates);
      if (updatedGoal) {
        setGoals(prev => 
          prev.map(goal => 
            goal.id === id ? updatedGoal : goal
          )
        );
      }
      return updatedGoal;
    } catch (error) {
      console.error('Error updating goal:', error);
      return null;
    }
  };

  const deleteGoal = (id) => {
    try {
      const success = goalStorage.delete(id);
      if (success) {
        setGoals(prev => prev.filter(goal => goal.id !== id));
      }
      return success;
    } catch (error) {
      console.error('Error deleting goal:', error);
      return false;
    }
  };

  const addProgressEntry = (goalId, progressData) => {
    try {
      const updatedGoal = goalStorage.addProgressEntry(goalId, progressData);
      if (updatedGoal) {
        setGoals(prev => 
          prev.map(goal => 
            goal.id === goalId ? updatedGoal : goal
          )
        );
      }
      return updatedGoal;
    } catch (error) {
      console.error('Error adding progress entry:', error);
      return null;
    }
  };

  const getGoal = (id) => {
    return goals.find(goal => goal.id === id) || null;
  };

  const getGoalsByStudent = (studentId) => {
    return goals.filter(goal => goal.studentId === studentId);
  };

  return {
    goals,
    loading,
    addGoal,
    updateGoal,
    deleteGoal,
    addProgressEntry,
    getGoal,
    getGoalsByStudent,
    refreshGoals: loadGoals
  };
};